/* accordion */
var collContents = document.getElementsByClassName("accordion-da-content");
var coll = document.getElementsByClassName("accordion-da");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function () {
    // this.classList.toggle("active");
    var n = 0;
    if (this.classList.contains("active")) {
      for (n = 0; n < coll.length; n++) {
        coll[n].classList.remove("active");
      }
    } else {
      for (n = 0; n < coll.length; n++) {
        coll[n].classList.remove("active");
      }

      this.classList.toggle("active");
    }
  });
}
/* end accordion */